export enum InMailStatusEnum {
  Sent,
  Archived,
  Deleted
}
